// Polyfill for Array.prototype.at and String.prototype.at (ES2022)
// Required for older Chromium-based kiosk/embedded browsers that lack this method.
// Without this, third-party injected scripts (e.g., device management agents) using
// .at() crash the app with "TypeError: .at is not a function".
(function () {
  function atPolyfill(index) {
    var len = this.length;
    var relativeIndex = Math.trunc(index) || 0;
    if (relativeIndex < 0) relativeIndex += len;
    if (relativeIndex < 0 || relativeIndex >= len) return undefined;
    return this[relativeIndex];
  }

  if (!Array.prototype.at) {
    Object.defineProperty(Array.prototype, 'at', {
      value: atPolyfill,
      writable: true,
      enumerable: false,
      configurable: true,
    });
  }

  if (!String.prototype.at) {
    Object.defineProperty(String.prototype, 'at', {
      value: atPolyfill,
      writable: true,
      enumerable: false,
      configurable: true,
    });
  }
})();
